'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../../components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _YellowLineSVG = require('../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _CopyWrapper = require('./components/CopyWrapper');

var _CopyWrapper2 = _interopRequireDefault(_CopyWrapper);

var _Image = require('./components/Image');

var _Image2 = _interopRequireDefault(_Image);

var _Subtitle = require('./components/Subtitle');

var _Subtitle2 = _interopRequireDefault(_Subtitle);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# I Am Hero
The hero section to be used for the "I Am" landing pages
 */
var HomePageHero = function HomePageHero(_ref) {
  var imgSrc = _ref.imgSrc,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === undefined ? '' : _ref$subtitle,
      _ref$buttonLabel = _ref.buttonLabel,
      buttonLabel = _ref$buttonLabel === undefined ? '' : _ref$buttonLabel,
      _ref$buttonLink = _ref.buttonLink,
      buttonLink = _ref$buttonLink === undefined ? '' : _ref$buttonLink;
  return _react2.default.createElement(
    _Wrapper2.default,
    {
      $imgSrc: imgSrc
    },
    _react2.default.createElement(_Image2.default, {
      $imgSrc: imgSrc
    }),
    _react2.default.createElement(
      _CopyWrapper2.default,
      null,
      (title || subtitle) && _react2.default.createElement(_YellowLineSVG2.default, null),
      title && _react2.default.createElement(
        _Title2.default,
        null,
        title
      ),
      subtitle && _react2.default.createElement(
        _Subtitle2.default,
        null,
        subtitle
      ),
      buttonLabel && buttonLink && _react2.default.createElement(
        _Button2.default,
        {
          onClick: function onClick() {
            window.location = buttonLink;
          }
        },
        buttonLabel
      )
    )
  );
};

HomePageHero.propTypes = {
  /** a URL for the hero image. */
  imgSrc: _propTypes2.default.string.isRequired,
  /** optional title. */
  title: _propTypes2.default.string,
  /** optional subtitle. */
  subtitle: _propTypes2.default.string,
  /** optional label for the button. */
  buttonLabel: _propTypes2.default.string,
  /** optional link to navigate to when the button is pressed. */
  buttonLink: _propTypes2.default.string
};

HomePageHero.displayName = 'HomePageHero';

exports.default = HomePageHero;
HomePageHero.__docgenInfo = {
  'description': '# I Am Hero\r\nThe hero section to be used for the "I Am" landing pages',
  'methods': [],
  'displayName': 'HomePageHero',
  'props': {
    'title': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'optional title.'
    },
    'subtitle': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'optional subtitle.'
    },
    'buttonLabel': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'optional label for the button.'
    },
    'buttonLink': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'optional link to navigate to when the button is pressed.'
    },
    'imgSrc': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'a URL for the hero image.'
    }
  }
};